import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  row1: {
    width: '240px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(6),
    '& > *': {
      marginLeft: theme.spacing(0),
      margin: theme.spacing(1),
    },
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
}));

const PlayerToolbar = props => {
  const { 
    className, 
    userRole,
    onClickOpenRegisterDialog,
    onClickOpenEditDialog,
    onClickOpenDeleteDialog,
    disableRegisterButton,
    disableEditButton,
    disableDeleteButton,
    ...rest
 } = props;

  const classes = useStyles();

  return (
    <div>
      {userRole !== 'user' && (
      <div className={classes.row} spacing={2}>
        <Button
          color="primary"
          variant="contained"
          disabled={ disableRegisterButton }
          onClick={ onClickOpenRegisterDialog }
        >
          등록
        </Button>

        <Button
          color="primary"
          variant="contained"
          disabled={ disableEditButton }
          onClick={ onClickOpenEditDialog }
        >
          수정
        </Button>

        <Button
          style={{
            //  borderRadius: 35,
              backgroundColor: disableDeleteButton ? "#DCDBDC" : "#E00000",
              color: disableDeleteButton ? "#A6A6A6":"#FFFFFF"
              // padding: "18px 36px",
              // fontSize: "18px"
            }}
          variant="contained"
          disabled={ disableDeleteButton }
          onClick={ onClickOpenDeleteDialog }
        >
          삭제
        </Button>
      </div>
      )}
    </div>
  );
};

PlayerToolbar.propTypes = {
  className: PropTypes.string
};

export default PlayerToolbar;
